module.exports = __webpack_public_path__ + "img/157.280d22ea.jpg";